import { useEffect, useState } from "react";
import { Gift, Tag } from "lucide-react";
import { PortalShell } from "@/components/AppHeader";
import { api, fmtDate, money } from "@/lib/api";

const off = (s) => (s.discount_type === "percent" ? `${s.value}% off` : `${money(s.value)} off`);

export function CustomerPromos() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/promos").then(({ data }) => setData(data)); }, []);
  return (
    <PortalShell>
      <p className="lux-eyebrow">Rewards</p>
      <h1 className="mt-2 text-3xl font-semibold text-amber-50 sm:text-4xl">Promos & specials</h1>
      {data && (
        <div className="mt-8 space-y-6" data-testid="customer-promos">
          <div className="lux-card p-6" data-testid="tier-progress">
            <p className="lux-eyebrow">Multi-trip discount</p>
            <p className="mt-3 text-amber-50">You've completed <span data-testid="completed-trip-count" className="font-semibold">{data.completed_trips}</span> trips.
              {data.current_tier ? <> Your <span className="text-emerald-300">{data.current_tier.percent}% discount</span> applies automatically.</> : " Keep riding to unlock a discount."}</p>
            <div className="mt-4 flex flex-wrap gap-2">{data.tiers.map((t) => <span key={t.min_trips} className="rounded-full border border-amber-500/30 px-3 py-1 text-xs text-amber-200">{t.min_trips}+ trips → {t.percent}%</span>)}</div>
          </div>
          <div className="grid gap-4 md:grid-cols-2">
            {data.specials.length === 0 && <p className="text-sm text-zinc-500">No specials right now.</p>}
            {data.specials.map((s) => (
              <div key={s.id} data-testid={`special-card-${s.code}`} className={`lux-card p-6 ${s.expired ? "opacity-50" : ""}`}>
                <div className="flex items-center justify-between"><Gift className="h-5 w-5 text-amber-400" /><span className="font-serif text-2xl text-amber-100">{off(s)}</span></div>
                <h3 className="mt-4 text-xl text-amber-50">{s.title}</h3>
                <p className="mt-2 text-sm text-zinc-400">{s.description}</p>
                <p className="mt-4 flex items-center gap-2 font-mono text-sm text-amber-300"><Tag className="h-4 w-4" />{s.code}</p>
                <p className="mt-1 text-xs text-zinc-500">{s.expired ? "Expired" : "Expires"} {fmtDate(s.expires_at)}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </PortalShell>
  );
}

export function DriverPromos() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/driver/promos").then(({ data }) => setItems(data)); }, []);
  return (
    <PortalShell>
      <p className="lux-eyebrow">For chauffeurs</p>
      <h1 className="mt-2 text-3xl font-semibold text-amber-50 sm:text-4xl">Driver promos</h1>
      <div className="mt-8 grid gap-4 md:grid-cols-2" data-testid="driver-promos">
        {items?.length === 0 && <p className="text-sm text-zinc-500">No promos right now.</p>}
        {items?.map((p) => (
          <div key={p.id} data-testid="driver-promo-card" className="lux-card p-6">
            <Gift className="h-5 w-5 text-amber-400" />
            <h3 className="mt-4 text-xl text-amber-50">{p.title}</h3>
            <p className="mt-2 text-sm text-zinc-300">{p.details}</p>
            <p className="mt-4 text-xs text-zinc-500">{p.start_date} → {p.end_date}</p>
          </div>
        ))}
      </div>
    </PortalShell>
  );
}
